<!-- 考试模式 -->
<template>
  <div class="wrap">
    <div v-if="!showSubmitPaper" class="header">
      <NavigateBar :title="isShowDeatail ? query.titleName :className" :isTop="true" @handleBack="handleBack">
          <template #titleMode>
            <span v-if="!isShowDeatail && (!query.isConsolidation || query.type == 'doPractice')" class="title-mode">考试模式</span>
          </template>
      </NavigateBar>
  </div>
  <div class="line"></div>
   <ScorePage v-if="showSubmitPaper" :type="query.type" :getScore="getScore" :totalScore="totalScore"/>
    <DetailsComponent v-if="isShowDeatail" :commentData="commentData" :questionList="questionList" @answerSheetClick="answerSheetClick" />
   <div v-if="!isShowDeatail && !showSubmitPaper" class="main" :style="{height: listHeight + 'px'}" @touchstart="touchstart" @touchend="touchend">
     <div class="taking">
       <div class="taking-content">
         <QuestionTitle :question="curQuestionData" :cur="curQuestionNum + 1" :total="questionList.length" />
         <TeacherFile :question="curQuestionData"/>
         {{ question.type }}
         <div v-if="curQuestionData.type !== 4" class="list">
           <QuestionOption
             v-for="(item, index) in curQuestionData.option"
             :option="item"
             :key="item.key"
             :index="index"
             :question="curQuestionData"
             @click="handleClick(item)"
             :pageType="query.type"
             :userSelect="userSelect"
           />
         </div>
         <div class="textarea" v-show="curQuestionData.type === 4">
           <van-field
               v-model="userAnswer"
               rows="1"
               show-word-limit
               style="width:100%"
               :readonly="Boolean(query.type == 'check')"
               maxlength="300"
               label-width="32px"
               :autosize="{minHeight: 140 }"
               label=""
               type="textarea"
               :class="Boolean(query.type == 'check') ? 'textarea-readonly' : ''"
               placeholder="请输入回答，限300字以内"
             />
         </div>
         <div class="attachment-list" v-if="attachmentList.length">
              <div class="attachment-item" v-for="(item,index) of attachmentList" :key="index">
              <img class="file-icon" :src="require(`@/assets/images/homeWork/${getFileType(item.title)}.png`)" />
              <div class="upload-status">
                  <div class="attachment-name">{{ item.title }}</div>
                  <div class="progress" v-if="!item.done && !item.err && item.progress">
                  <span>{{(item.progress.loaded/(1024*1024)).toFixed(2)}}M/{{(item.progress.total/(1024*1024)).toFixed(2)}}M</span>
                  <van-progress
                  :percentage="item.progress.percent*100"
                  :show-pivot	="false"
                  pivot-color="rgb(255,255,255)"
                  color="#10A675"
                  style="width:155px; margin:0 6px"></van-progress>
                  <span>{{(item.progress.speed/(1024*1024)).toFixed(2)}}m/s</span>
                  </div>
                  <div class="progress" v-else-if="item.done && !item.err && item.progress">
                  <span>大小：{{(item.progress.total/(1024*1024)).toFixed(2)}}M</span>
                  </div>
                  <div class="progress" v-else-if="item.size">
                  <span>大小：{{item.size}}M</span>
                  </div>
                  <div class="progress" v-else-if="item.err">
                  <span style="color:#F56C6C">上传失败，请删除重新上传</span>
                  </div>
              </div>
              <img class="close-icon" v-if="!Boolean(query.type == 'check')" src="../../assets/img/ico_guanbi@2x.png" @click="deleteAttachment(index)" />
              </div>
           </div>
         <div class="add-attachment" @click="chooseFile" v-if="curQuestionData.type == 4 && (query.type == 'do' || query.type == 'edit' || query.type == 'doPractice')">
           <img src="../../assets/images/homeWork/ico_add@2x.png" />
           <span>添加附件</span>
           <input type="file" style="display: none" ref="updateFile" @change="afterRead($event)" />
         </div>
         <QuestionParse 
         v-if="query.type == 'check'"
         :question="curQuestionData"
         :indexanawer='indexanawer'
         :comment="questionComment"
         :cur="curQuestionNum + 1"
         :total="questionList.length"
         :modeType="query.isHistory ? 2 : 1"
         />
         <!-- <CommentFile :file="commentFile" v-show="(curQuestionNum + 1) == questionList.length"/> -->
       </div>
     </div>
     <!-- 上一题下一题 -->
     <div class="question-switch">
      <changeWork :questionList="questionList" :curQuestionNum="curQuestionNum" @handleClick="changeClick" />
    </div>
   </div>
   <div v-if="!isShowDeatail && !showSubmitPaper" class="switch-question">
      <div class="switch-next-question draft" @click="toPrevQuestionbc" v-if="query.flag == 1">
        <span>保存草稿</span>
      </div>
      <div class="switch-next-question draft" @click="toPrevQuestionbc" v-if="query.flag == 2">
        <span>保存草稿</span>
      </div>
      <div class="switch-next-question draft nobackground" v-if="query.flag == 0">
      </div>
      <div v-if="isEnd && query.isShowSubmit" class="switch-next-question draft present" @click="toNextQuestion">
        <span>提 交</span>
      </div>
      <div class="switch-next-question question-submit" @click="isShowAnswerSheet = true">
        <img src="@/assets/images/homeWork/answer.png" alt="">
        答题卡
      </div>
    </div>
    <van-dialog v-model="confirmShow"
      title="提示"
      :show-cancel-button="isAllDone"
      width="280px"
      @confirm="dialogConfirm"
      confirmButtonColor="#286BFF"
    >
      <div style="width:250px; text-align:center">
        {{dialogText}}
      </div>
    </van-dialog>
    <van-popup v-model="isShowAnswerSheet" position="bottom" safe-area-inset-bottom round :style="{ maxHeight: '566px' }" >
      <div style="padding: 24px;">
        <answerSheet :questionList="questionList" :curQuestionNum="curQuestionNum" :modeType="query.isShowSubmit ? 1 : 2" :isShowSubmit="query.isShowSubmit" @handleClick="answerSheetClick" @btnSubmitClick="btnSubmitClick" />
      </div>
    </van-popup>
  </div>
 </template>
 
 <script>
import uploadFile from '@/utils/cosUpload'
import { FileUpladType } from '@/utils/constant'
import NavigateBar from './navigateBar.vue';
import QuestionTitle from './refactorComponents/questionTitle.vue'
import QuestionOption from './refactorComponents/questionOption.vue'
import QuestionParse from './refactorComponents/questionParse.vue'
import TeacherFile from './refactorComponents/teacherFile.vue'
import ScorePage from './refactorComponents/scorePage.vue'
import answerSheet from './refactorComponents/answerSheet.vue'
import DetailsComponent from './refactorComponents/details.vue'
import changeWork from './refactorComponents/changeWork.vue'
import COS from 'cos-js-sdk-v5'
import { getFileType } from '@/utils/index.js'

 
 import Vue from 'vue';
 import { Progress, Dialog, Notify, Toast, Popup } from 'vant';
 
 Vue.use(Toast)
 Vue.use(Progress);
 Vue.use(Dialog, Popup);
 export default {
   props: { },
   data () {
     return {
      query: {},
      isShowAnswerSheet: false,
      className: '写作业',
      indexanawer: '',
      testType: 0, // 0 模拟考试 1 背题 2 顺序答题 3 查看试卷
      showFb: false, // 展示反馈弹窗
      uqid: undefined,
      number: undefined,
      set: 0,
      question: {},
      cid: '',
      touchX: 0,
      orderType: 0, // 答题模式 0	背题模式 1
      userSelect: [],
      timer: null,
      userAnswer: '', // 用户简答题答案,
      canChangeList: [0, 2],
      showSubmit: false,
      testId: undefined,
      countDown: '00:00:00',
      timer1: null,
      showTime: false,
      onlyShowFail: false, // 仅显示错题
      questionList: [],
      cos:{},
      attachmentList:[],
      confirmShow:false,
      curQuestionData:{},
      curQuestionNum:0,
      dialogText:'',
      isAllDone:true,
      questionComment:'',
      commentData: {},
      uploading:false,
      dialogType:1, // 提交作业 1   返回继续 2   退出页面  3 巩固练习 4
      showSubmitPaper:false,
      getScore:0,
      totalScore:0,
      commentFile:[],
      isShowDeatail: false,
      innerHeight: null
     }
   },
   created(){
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      overlay: true,
      loadingType: 'spinner',
      duration: 0
    });
    //  this.initCos()
     this.innerHeight = window.innerHeight
     const {payload}=this.$route.query
     this.query = JSON.parse(decodeURIComponent(payload))
     console.log('query',this.query)
     this.isShowDeatail = !this.query.isShowSubmit
     if(this.query.type == 'do' || this.query.type == 'doPractice'){
       this.getQuestionContent()
     }
     if(this.query.type == 'check' || this.query.type == 'edit'){
       this.getDoneQuestionContent()
     }
   },
   components:{
     NavigateBar,
     QuestionTitle,
     QuestionOption,
     QuestionParse,
     TeacherFile,
     ScorePage,
     answerSheet,
     DetailsComponent,
     changeWork
   },
   computed: { 
     showParse() {
             let flag = false;
             const { testType } = this;
             if (testType == 0) {
                 flag = false
             } else {
                 flag = true;
             }
             return flag;
         },
     isEnd () {
         return this.curQuestionNum+1 >= this.questionList.length
       },
     isFirst () {
       return this.curQuestionNum <= 0
     },
     listHeight() {
       return this.innerHeight -  50 - 52
     }
   },
     // watch: {
     // 	number() {
     // 		this.getDetail();
     // 	}
     // },
   watch:{
     curQuestionNum(val){
       this.userSelect=[]
       this.userAnswer = ''
       this.attachmentList=[]
       this.curQuestionData = {}
       this.curQuestionData = this.questionList[val]
       console.log('val', val, this.questionList)
       console.log('this.curQuestionData',this.curQuestionData)
       console.log(this.curQuestionData.user_answer)
       if(this.curQuestionData.type != 4 && this.curQuestionData.user_answer){
         this.userSelect = this.curQuestionData.user_answer.length > 0 ? this.curQuestionData.user_answer.split('') : ''
         console.log('this.userSelect',this.userSelect)
         return
       }
       if(this.curQuestionData.type == 4){
         this.userAnswer = this.curQuestionData.user_answer
         this.analysis = this.curQuestionData.analysis
         this.attachmentList = this.curQuestionData.answer_file || []
         return
       }
     }
    },
   mounted() { },
   methods:{
     getFileType,
     // c初始cos
     initCos(){
       this.cos = new COS({
       // getAuthorization 必选参数
       getAuthorization: function (options, callback) {
         // 异步获取临时密钥
         // 服务端 JS 和 PHP 例子：https://github.com/tencentyun/cos-js-sdk-v5/blob/master/server/
         // 服务端其他语言参考 COS STS SDK ：https://github.com/tencentyun/qcloud-cos-sts-sdk
         // STS 详细文档指引看：https://cloud.tencent.com/document/product/436/14048
         const baseUrl = process.env.VUE_APP_API_ONLINE_SCHOOL
 
         var url = `${baseUrl}/onlineapi/common/index/getCosSign` // url替换成您自己的后端服务
         var xhr = new XMLHttpRequest()
         xhr.open('GET', url, true)
         xhr.onload = function (e) {
           try {
             var data = JSON.parse(e.target.responseText)
             var credentials = data.data.credentials
           } catch (e) {
             console.log(e);
           }
           if (!data || !credentials) {
             return console.error(
               'credentials invalid:\n' + JSON.stringify(data, null, 2)
             )
           }
           callback({
             TmpSecretId: credentials.tmpSecretId,
             TmpSecretKey: credentials.tmpSecretKey,
             SecurityToken: credentials.sessionToken,
             // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
             StartTime: data.data.startTime, // 时间戳，单位秒，如：1580000000
             ExpiredTime: data.data.expiredTime, // 时间戳，单位秒，如：1580000000
           })
         }
         xhr.send()
       },
     })
     },
       // 获取当前题目内容请求
     async getQuestionContent () {
         const data = { qt_id: this.query.qt_id }
         const res = await this.$api.post('/user/index/dotask', data)
         if (res.data.code === 200) {
           this.questionList = res.data.data
           this.questionList.forEach(item=>{
             if(item.type == 3){
               item.option = [{key:'1',value:'正确'},{key:'2',value:'错误'}]
             }
           })
           if(this.questionList.length){
             this.curQuestionData = this.questionList[0]
           }
           this.totalScore = this.questionList.reduce((total,item)=>{return total+item.score},0)
           Toast.clear()
         } else {
           Toast.clear()
         }
     },
     async getDoneQuestionContent () {
         let data = { qt_id: this.query.qt_id, section_id:this.query.section_id, chapter_id:this.query.chapter_id,ucqid:this.query.ucqid}
         let isHistorySee = false
         let urlLink = '/user/index/see'
         if (this.query.isConsolidation) {
           urlLink = '/user/question/historySee'
           data = { uhq_id: this.query.consolidationId }
           isHistorySee = true
         }
         const res = await this.$api.post(urlLink, data)
         if (res.data.code === 200) {
           let list = res.data.data.answer_list || res.data.data.questions
           this.questionList = list.map(item=>{
              if (!isHistorySee) {
                item.id = item.qid
                delete item.qid
              }
              item.isShow = item.user_answer ? true : false
              return item
           })
           this.questionList.forEach(item=>{
             if(item.type !== 4){
               const correctAnswer = item.answer.length > 0 ? item.answer.split('').sort().join() : ''
               const userAnswer = item.user_answer.length > 0 ? item.user_answer.split('').sort().join() : ''
               if(correctAnswer == userAnswer){
                 item.row = 1
               }
             }
             if(item.type == 3){
               item.option = [{key:'1',value:'正确'},{key:'2',value:'错误'}]
             }
           })
           this.totalScore = res.data.data.comment ? res.data.data.comment.total : res.data.data.score
           this.getScore = res.data.data.comment ? res.data.data.comment.user_score : this.query.workScore
           if(this.questionList.length){
             if(this.query.type == 'check' && this.query.status == 2){
               this.curQuestionData = this.questionList[this.questionList.length-1]
               this.curQuestionNum = this.questionList.length-1
               let comment = {}
               /* 
                处理historySee接口跟see接口返回的参数不同进行处理
               */
               if (res.data.data.comment) {
                 this.questionComment = res.data.data.comment.comment
                 this.commentFile = res.data.data.comment.files
                 comment = res.data.data.comment
                } else {
                  comment.total =  res.data.data.score
                  comment.user_score = this.query.workScore
                }
                this.commentData = comment
             }
             this.curQuestionData = this.questionList[0]
           }
           Toast.clear()
           if(this.curQuestionData.type != 4 && this.curQuestionData.user_answer){
             this.userSelect = this.curQuestionData.user_answer.length > 0 ? this.curQuestionData.user_answer.split('') : ''
             return
           }
           if(this.curQuestionData.type == 4 && this.curQuestionData.user_answer){
             this.userAnswer = this.curQuestionData.user_answer
             this.analysis = this.curQuestionData.analysis
             this.attachmentList = this.curQuestionData.answer_file || []
             return
           }
         } else {
           Toast.clear()
         }
       },
     async handleClick(item) {
        if (this.showLoading) return;
        // this.userSelect = item.key === this.userSelect ? '' : item.key;
        if (this.curQuestionData.answer && this.query.type == 'check') return;
        // debugger
        const userSelect = this.userSelect;
        if (this.curQuestionData.type === 2) {
            if (userSelect.includes(item.key)) {
                this.userSelect = userSelect.filter(t => item.key !== t);
            } else {
                this.userSelect.push(item.key);
            }
        } else {
            this.userSelect = [item.key];
        }
    },
     chooseFile() {
       this.$refs.updateFile.click()
       },
           // 上传头像
       async afterRead(e) {
       // 此时可以自行将文件上传至服务器
       let file = e.target.files[0]
       console.log(file)
       this.attachmentList.push({title:file.name, done:false, err:false})
       this.uploading = true
       try {
          const ossUrl = await uploadFile(file, FileUpladType.HOMEWORK, (process) => {
            this.attachmentList.forEach((item,i)=>{
              if(item.title === file.name){
                this.$set(this.attachmentList[i], 'progress', process)
              }
            })
          })
          this.attachmentList.forEach((item,i)=>{
            if(item.title === file.name){
              this.$set(this.attachmentList[i], 'done', true)
              this.$set(this.attachmentList[i], 'url', ossUrl)
            }
          })
        } catch(error) {
          console.log('error: ', error)
        } finally {
          this.uploading = false
        }
     },
     deleteAttachment(index){
       this.uploading = false
       this.attachmentList.splice(index,1)
     },
     changeClick(mode) {
      if (mode == 'left') {
        this.toPrevQuestion()
      } else if (mode == 'right') {
        this.toNextQuestion()
      }
     },
     toPrevQuestion(){
       if(this.query.type == 'check'){
           this.curQuestionNum--
           return
         }
         if(this.uploading){
             Notify('请等待文件上传完成再操作')
           return
         }
         if(this.userSelect.length){
           this.questionList.forEach(item=>{
             if(item.id == this.curQuestionData.id){
               item.user_answer = this.userSelect.join('')
             }
           })
         }
         if(this.userAnswer){
           this.questionList.forEach(item=>{
             if(item.id == this.curQuestionData.id){
               item.user_answer = this.userAnswer
             }
           })
         }
         if(this.attachmentList.length){
           this.questionList.forEach(item=>{
             if(item.id == this.curQuestionData.id){
               item.answer_file= this.attachmentList.map(item=>{
                 if(item.size){
                   return {
                     title:item.title,
                     url:item.url,
                     size:item.size
                   }
                 }else{
                   return {
                     title:item.title,
                     url:item.url,
                     size:(item.progress.total/(1024*1024)).toFixed(2)
                   }
                 }
 
               })
             }
           })
         }
         this.curQuestionNum--
     },
     toNextQuestion(){
       if(this.query.type == 'check'){
           this.curQuestionNum++
           return
         }
         if(this.uploading){
           Notify('请等待文件上传完成再操作')
           return
         }
         
         if(this.userSelect.length){
           this.questionList.forEach(item=>{
             if(item.id == this.curQuestionData.id){
               item.user_answer = this.userSelect.join('')
             }
           })
         }
         if(this.userAnswer){
           this.questionList.forEach(item=>{
             if(item.id == this.curQuestionData.id){
               item.user_answer = this.userAnswer
             }
           })
         }
         if(this.attachmentList instanceof Array && (this.attachmentList.length || this.attachmentList.length === 0)){
           this.questionList.forEach(item=>{
             if(item.id == this.curQuestionData.id){
               item.answer_file= this.attachmentList.map(item=>{
                 if(item.size){
                   return {
                     title:item.title,
                     url:item.url,
                     size:item.size
                   }
                 }else{
                   return {
                     title:item.title,
                     url:item.url,
                     size:(item.progress.total/(1024*1024)).toFixed(2)
                   }
                 }
 
               })
             }
           })
         }
         if(this.isEnd && this.query.type !== 'doPractice'){
           const result = this.questionList.some(item=> !item.user_answer)
           const endTime = new Date(this.query.end_time).getTime()
           const nowTime = new Date().getTime()
           if(result){
             this.dialogText = '当前有作业未填写，请填写后提交'
           }else{
             if(nowTime>endTime){
               this.dialogText="当前已过截止时间，提交后为迟交状态，确定还要提交吗？"
             }else{
               this.dialogText="请仔细检查作业，是否确认提交"
             }
           }
           this.dialogType = result? 2 : 1
           this.isAllDone = !result
           this.confirmShow = true
           return
         }
         if (this.isEnd && this.query.type === 'doPractice') {
           const result = this.questionList.some(item=> !item.user_answer)
           if (result) {
             this.dialogText = '当前有作业未填写，请填写后提交'
           } else {
             this.dialogText = '请仔细检查作业，是否确认提交'
           }
           this.isAllDone = !result
           this.confirmShow = true
           this.dialogType = 4
           return
         }
         this.curQuestionNum++
         
         // this.briefAnswer = ''
         // this.singleSelectRadio = ''
         // this.multipleList = []
     },
     handleBack(){
       if(this.query.flag == 1) {
         this.$router.go(-1)
       } else {
         if(this.showSubmitPaper || this.query.type == 'check') {
           if (this.isShowDeatail) {
            this.$router.go(-1)
          }
          this.isShowDeatail = true
           return
         }
         this.dialogText = '返回将不会保存填写的内容，确定返回吗？'
         if (this.query.type == 'doPractice') {
           this.dialogText = '退出本次练习不计算成绩,是否确认退出？'
         }
         this.dialogType = 3
         this.confirmShow = true
       }
     },
     dialogConfirm(){
       if(this.dialogType == 3){
         this.$router.back()
       }
       if(this.dialogType == 1 || this.dialogType == 4){
         this.submitAnswer()
         this.isShowAnswerSheet = false
       }
     },
     async toPrevQuestionbc(){
       const content = this.questionList.map(item=>{
         if(this.userSelect.length){
             if(item.id == this.curQuestionData.id){
               item.user_answer = this.userSelect.join('')
             }
         }
         if(this.userAnswer){
             if(item.id == this.curQuestionData.id){
               item.user_answer = this.userAnswer
             }
         }
         if(this.attachmentList instanceof Array && (this.attachmentList.length || this.attachmentList.length === 0)){
             if(item.id == this.curQuestionData.id){
               item.answer_file= this.attachmentList.map(item=>{
                 if(item.size){
                   return {
                     title:item.title,
                     url:item.url,
                     size:item.size
                   }
                 }else{
                   return {
                     title:item.title,
                     url:item.url,
                     size:(item.progress.total/(1024*1024)).toFixed(2)
                   }
                 }
 
               })
             }
         }
             if(item.type == 4){
               if(item.user_answer == null) {
                 item.user_answer = ''
               }
             return{
               file:item.answer_file?JSON.stringify(item.answer_file) || "" : '',
               qid:item.id,
               title:item.title,
               answer:item.user_answer,
               type:item.type,
               score:0
             }
           }else{
             if(item.user_answer == null) {
               item.user_answer = ''
             }
             return{
               qid:item.id,
               title:item.title,
               answer:item.user_answer,
               type:item.type,
               file:item.answer_file?JSON.stringify(item.answer_file) || "" : '',
               score:[...item.user_answer].sort().toString() == [...item.answer].sort().toString()?item.score:0
             }
           }
         })
         this.getScore = content.reduce((total,item)=>{return total+item.score},0)
         const data = {
           cq_id: this.query.cq_id,
           content:JSON.stringify(content),
           mode: 1
       }
       const res = await this.$api.post('/user/index/save', data)
       if (res.data.code === 200) {
         Toast.success('保存草稿成功')
         this.query.flag = 1
       }else{
           Notify(res.data.message)
       }
     },
     async submitAnswer(){
       const content = this.questionList.map(item=>{
             if(item.type == 4){
             return{
               file:item.answer_file?JSON.stringify(item.answer_file) || "" : '',
               qid:item.id,
               title:item.title,
               answer:item.user_answer,
               type:item.type,
               score:0
             }
           }else{
             return{
               qid:item.id,
               title:item.title,
               answer:item.user_answer,
               type:item.type,
               file:item.answer_file?JSON.stringify(item.answer_file) || "" : '',
               score:[...item.user_answer].sort().toString() == [...item.answer].sort().toString()?item.score:0,
               isSuccess: [...item.user_answer].sort().toString() == [...item.answer].sort().toString() ? true : false
             }
           }
         })
         this.getScore = content.reduce((total,item)=>{return total+item.score},0)
         let data = {
           cq_id: this.query.cq_id,
           content:JSON.stringify(content),
           mode: 1
       }

      let urlLink = '/user/index/submit'
      if (this.query.isConsolidation) {
        urlLink = '/user/question/historySubmit'
        data = { cq_id: this.query.cq_id, ucq_id: this.query.ucqid, content: JSON.stringify(content) }
      }

       const res = await this.$api.post(urlLink, data)
       if (res.data.code === 200) {
           this.showSubmitPaper = true
       }else{
           Notify(res.data.message)
       }
     },
     touchstart(e) {
          const { changedTouches } = e;
          const { clientX } = changedTouches[0];
          this.touchX = clientX;
      },
      touchend(e) {
          const { changedTouches } = e;
          const { clientX } = changedTouches[0];
          if (clientX - this.touchX >= 100 && !this.isFirst) {
              this.toPrevQuestion()
          } else if (this.touchX - clientX >= 100 && !this.isEnd) {
              this.toNextQuestion()
          }
          this.touchX = 0;
      },
      answerSheetClick(item, index) {
        this.isShowDeatail = false
        console.log(this.userSelect)
        if(this.userSelect.length){
           this.questionList.forEach(item=>{
             if(item.id == this.curQuestionData.id){
               item.user_answer = this.userSelect.join('')
             }
           })
         }
        if(this.userAnswer){
           this.questionList.forEach(item=>{
             if(item.id == this.curQuestionData.id){
               item.user_answer = this.userAnswer
             }
           })
         }
         /* 判断前一个值是否点了答题 未点击 则为已答状态（答题卡）*/
        let prevData = this.questionList[this.curQuestionNum]
        console.log('answerSheetClickprevData', prevData)
        console.log(prevData.isShow, prevData.user_answer)
        if (!prevData.isShow && prevData.user_answer) {
          console.log('变成已答状态')
          prevData.isShowAnswered = true
        }
         if(this.attachmentList instanceof Array && (this.attachmentList.length || this.attachmentList.length === 0)){
           this.questionList.forEach(item=>{
             if(item.id == this.curQuestionData.id){
               item.answer_file= this.attachmentList.map(item=>{
                 if(item.size){
                   return {
                     title:item.title,
                     url:item.url,
                     size:item.size
                   }
                 }else{
                   return {
                     title:item.title,
                     url:item.url,
                     size:(item.progress.total/(1024*1024)).toFixed(2)
                   }
                 }
 
               })
             }
           })
         }
         this.$nextTick(() => {
          this.curQuestionNum = index
         })
         this.isShowAnswerSheet = false
      },
      btnSubmitClick() {
        console.log(12)
        if(this.uploading){
           Notify('请等待文件上传完成再操作')
           return
         }
         if(this.userAnswer){
           this.questionList.forEach(item=>{
             if(item.id == this.curQuestionData.id){
               item.user_answer = this.userAnswer
             }
           })
         }
        if(this.query.type !== 'doPractice'){
           const result = this.questionList.some(item=> !item.user_answer)
           const endTime = new Date(this.query.end_time).getTime()
           const nowTime = new Date().getTime()
           if(result){
             this.dialogText = '当前有作业未填写，请填写后提交'
           }else{
             if(nowTime>endTime){
               this.dialogText="当前已过截止时间，提交后为迟交状态，确定还要提交吗？"
             }else{
               this.dialogText="请仔细检查作业，是否确认提交"
             }
           }
           this.dialogType = result? 2 : 1
           this.isAllDone = !result
           this.confirmShow = true
           return
         }
         if (this.query.type === 'doPractice') {
           const result = this.questionList.some(item=> !item.user_answer)
           if (result) {
             this.dialogText = '当前有作业未填写，请填写后提交'
           } else {
             this.dialogText = '请仔细检查作业，是否确认提交'
           }
           this.isAllDone = !result
           this.confirmShow = true
           this.dialogType = 4
           return
         }
      }
   }
 }
 </script>
 
 <style lang="scss" scoped>
 .wrap{
   width: 100%;
   height: 100%;
   background: #ffffff;
 }
 .header{
      box-sizing: border-box;
      padding: 0 10px 0 20px;
      .title-mode {
          display: inline-block;
          padding: 4px 12px;
          box-sizing: border-box;
          background: #eaf1ff;
          border-radius: 100px;
          color: #286BFF;
          font-size: 12px;
          font-weight: normal;
          margin-left: 8px;
      }
   }
 .main{
   padding: 2px 28px;
   box-sizing: border-box;
   // padding-bottom: 50px;
   background: #ffffff;
   .score{
     height: 40px;
     display: flex;
     background: #E7F6F1;
     box-sizing: border-box;
     padding: 0 10px;
     align-items: center;
     div{
       color: #202020;
       font-size: 14px;
       span{
         margin-left: 8px;
       }
     }
     .total{
       span{
         font-weight: 600;
       }
     }
     .get{
       margin-left: auto;
       span{
         font-size: 20px;
         color: #24AE81;
       }
     }
   }
 }
 .taking {
     box-sizing: border-box;
     padding: 12px 0;
     max-height: calc(100vh - 50px - 52px - 54px);
     overflow-y: scroll;
     overflow: auto; /* 保持滚动功能 */
     scrollbar-width: none; /* Firefox */
     -ms-overflow-style: none;
     &::-webkit-scrollbar {
         display: none; /* Safari 和 Chrome */
     }
     .taking-content {
      //    padding: 16px 0 50px;
     }
 }
 .question-switch {
  margin-top: calc(24px - 12px);
 }
 .list {
     // padding: 0 0 20px 0;
     margin-top: 8px;
 }
 .submit {
     width: 630rpx;
     height: 88rpx;
     line-height: 88rpx;
     text-align: center;
     background: linear-gradient(315deg, #ed3f10, #fb724d 100%);
     border-radius: 44rpx;
     margin: 60rpx auto;
     font-size: 32rpx;
     color: #ffffff;
 }
 .textarea {
     width: 100%;
     margin: 12px auto 0;
     ::v-deep .van-field {
         padding: 0;
        background-color: #fff;
        textarea {
            border-radius: 8px;
            padding: 10px 16px;
            border: 1px solid #F0F4F5;
            &:focus {
                border: 1px solid #286BFF;
            }
         }
     }
     .textarea-readonly {
        ::v-deep .van-field__control {
          background-color: #F0F4F5 !important;
          border: none;
        }
     }
 }
 .add-attachment{
   color: #286BFF;
   box-sizing: border-box;
   display: flex;
   align-items: center;
   margin-top: 8px;
   font-size: 15px;
   cursor: pointer;
   img{
     width: 16px;
     height: 16px;
     margin-right: 4px; 
   }
 }
 .attachment-list{
   margin-top: 8px;
   box-sizing: border-box;
   .attachment-item{
     // height: 64px;
     background: #F4F6F6;
     display: flex;
     align-items: center;
     box-sizing: border-box;
     padding: 5px 16px 5px 6px;
     margin-bottom: 10px;
     border-radius: 8px;
     .attachment-name{
       max-width: 250px;
       overflow:hidden;
       text-overflow:ellipsis;
       white-space:nowrap
     }
     .file-icon{
       width: 32px;
       height: 32px;
       margin-right: 10px;
     }
     .upload-status{
       .progress{
         display: flex;
         margin-top: 6px;
         align-items: center;
         max-width: 275px;
         ::v-deep .el-progress-bar__outer{
           background-color:#ffffff;
         }
         span{
           font-size: 12px;
           color: #888888;
         }
       }
     }
     .close-icon{
       width: 16px;
       height: 16px;
       margin-left: auto;
       cursor: pointer;
     }
   }
 }
 .switch-question{
   position: fixed;
   bottom: 0;
   left: 0;
   right: 0;
   display: flex;
   box-sizing: border-box;
   height: 52px;
   background: #ffffff;
   padding: 8px 24px;
  //  justify-content: space-between;
   align-items: center;
   border-top: 1px solid #E3E8E9;
   padding-bottom: calc(8px + constant(safe-area-inset-bottom)); /*兼容 IOS<11.2*/
   padding-bottom: calc(8px + env(safe-area-inset-bottom)); /*兼容 IOS>11.2*/
   .switch-next-question{
     width: 92px;
     height: 36px;
     background: #10a675;
     border-radius: 100px;
     font-size: 14px;
     text-align: center;
     color: #ffffff;
     line-height: 36px;
   }
   .draft {
      width: initial;
      flex: 1;
      background-color: #EAF1FF;
      color: #286BFF;
      &.nobackground {
          background-color: #ffffff;
      }
   }
   .present {
      margin-left: 12px;
      background-color: #286BFF;
      color: #ffffff;
   }
   .switch-prev-question{
     width: 92px;
     height: 34px;
     background: #EFF2F5;
     border-radius: 17px;
     font-size: 14px;
     text-align: center;
     color: #202020;
     line-height: 34px;
   }
   .question-submit {
      width: 80px;
      margin-left: 12px;
      display: flex;
      background-color: #ffffff;
      flex-direction: column;
      align-items: center;
      color: #202020;
      line-height: normal;
      font-size: 12px;
      img {
          width: 20px;
          height: 20px;
      }
   }
 }
 .line{
    width: 100%;
    height: 1px;
    background: #E3E8E9;
  }
 ::v-deep .van-dialog__content{
   display: flex;
   justify-content: center;
   margin: 16px 0;
 }
 ::v-deep .van-dialog__header{
   font-size: 18px;
   font-weight: 600;
   padding-top: 20px;
 }
 </style>